import { useWallOfLoveStore } from "../stores/wall-of-love-store";

export const useWallOfLoves = () => {
	const wallOfLoves = useWallOfLoveStore((state) => state.wallOfLove);
	const indexWallOfLove = useWallOfLoveStore((state) => state.index);
	const showWallOfLove = useWallOfLoveStore((state) => state.show);
	const createWallOfLove = useWallOfLoveStore((state) => state.create);
	const updateWallOfLove = useWallOfLoveStore((state) => state.update);
	const deleteWallOfLove = useWallOfLoveStore((state) => state.delete);
	const restoreWallOfLove = useWallOfLoveStore((state) => state.restore);
	const syncStaticReviews = useWallOfLoveStore((state) => state.syncStaticReviews);
	const syncPinnedReviews = useWallOfLoveStore((state) => state.syncPinnedReviews);
	const indexPinnedReviews = useWallOfLoveStore((state) => state.indexPinnedReviews);
	const previewWall = useWallOfLoveStore((state) => state.preview);

	return {
		wallOfLoves,
		indexWallOfLove,
		showWallOfLove,
		createWallOfLove,
		updateWallOfLove,
		deleteWallOfLove,
		restoreWallOfLove,
		syncStaticReviews,
		syncPinnedReviews,
		indexPinnedReviews,
		previewWall,
	};
};
